import { enCommonTranslations } from './locales/en/common';
import { enChatbotTranslations } from './locales/en/chatbot';

import { arCommonTranslations } from './locales/ar/common';
import { arChatbotTranslations } from './locales/ar/chatbot';


export const resources = {
	en: {
		translation: {
			...enCommonTranslations,
			...enChatbotTranslations,

		}
	},
	ar: {
		translation: {
			...arCommonTranslations,
			...arChatbotTranslations

		}
	}
};